import React from "react";
import "./styles.scss";
import { Modal, Spinner } from "react-bootstrap";
import { createChannel } from "../../../../api/sendbird_channels";
import { Sendbird } from "../../../../api/sendbird";
import { log_error } from "../../../../api";
import { indexUsers } from "../../../../api/users";
import OutsideAlerter from "./OutsideAlerter";
import _ from "lodash";
import UserTag from "../UserTag";

const sb = new Sendbird();
export default class SharingModal extends React.Component {
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });
  handleClick = e =>
    this.hocWrapper.current.contains(e.target) && this.handleShow();
  componentDidMount = () =>
    document.body.addEventListener("click", this.handleClick);
  componentWillUnmount = () =>
    document.body.removeEventListener("click", this.handleClick);
  textSetter = e =>
    this.setState({
      body: { ...this.state.body, text: e.target.value }
    });
  fetchSuggestions = username => {
    this.setState({ suggestions: null });
    indexUsers({ filter: { username } })
      .then(({ data: { users } }) => this.setState({ suggestions: users }))
      .catch(e => this.setState({ suggestions: [] }));
  };
  handleSubtmit = () => {
    if (!this.state.id) {
      this.setState({ error: "Please select a valid user" });
      return;
    }
    this.setState({ isLoading: true, error: null });
    createChannel({
      channel: {
        user_ids: [parseInt(sb.sb.currentUser.userId), this.state.id]
      }
    })
      .then(
        ({
          data: {
            channel: { channel_url }
          }
        }) => {
          sb.sb.GroupChannel.getChannel(channel_url, (groupChannel, error) => {
            if (error) {
              this.setState({ isLoading: false, error });
            } else
              sb.sendMessage(groupChannel, this.state.message)
                .then(data => this.handleClose())
                .catch(e => this.setState({ error: log_error(e) }))
                .finally(() => this.setState({ isLoading: false }));
          });
        }
      )
      .catch(error => {
        this.setState({ isLoading: false, error });
      });
  };
  init_state = {
    show: false,
    suggestions: [],
    username: this.props.username || "",
    message: "",
    id: this.props.id || null,
    error: null,
    isLoading: false
  };
  state = this.init_state;
  hocWrapper = React.createRef();
  render() {
    return (
      <>
        <button
          ref={this.hocWrapper}
          className={`${this.props.className} hor_click`}
        >
          {this.props.children}
        </button>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Body>
            <Modal.Title>Send a new message</Modal.Title>
            <div className="d-flex flex-column mt-3 text-center">
              <OutsideAlerter
                callBack={() => this.setState({ suggestions: [] })}
              >
                <div className="form-group position-relative">
                  <input
                    value={this.state.username}
                    onChange={e => {
                      this.fetchSuggestions(e.target.value);
                      this.setState({
                        username: e.target.value
                      });
                    }}
                    disabled={this.props.username && this.props.id}
                    id="username"
                    className="form-control"
                    autoComplete="off"
                    placeholder="Username"
                    onFocus={e => this.fetchSuggestions(e.target.value)}
                  />
                  {_.isNull(this.state.suggestions) ? (
                    <div className="autocomplete border py-3">
                      <Spinner
                        animation="border"
                        variant="primary"
                        size="lg"
                        role="status"
                      />
                    </div>
                  ) : this.state.suggestions.length ? (
                    <div className="autocomplete border">
                      {this.state.suggestions.map(user => (
                        <UserTag
                          className="px-2 py-1"
                          user={user}
                          disabled
                          onClick={() => {
                            this.setState({
                              username: user.username,
                              id: user.id,
                              suggestions: []
                            });
                          }}
                        />
                      ))}
                    </div>
                  ) : null}
                </div>
              </OutsideAlerter>
              <div className="form-group">
                <textarea
                  value={this.state.message}
                  onChange={e => this.setState({ message: e.target.value })}
                  className="form-control"
                  rows="3"
                  placeholder="Write your message"
                ></textarea>
              </div>
              <button
                disabled={this.state.isLoading}
                onClick={this.handleSubtmit}
                className="btn btn-light btn-sm"
              >
                {this.state.isLoading ? (
                  <Spinner animation="border" variant="primary" role="status" />
                ) : (
                  "Send"
                )}
              </button>
              {this.state.error && (
                <div className="my-2 text-center">
                  <p className="m-0 alert alert-danger">
                    {JSON.parse(JSON.stringify(this.state.error, null, 2))}
                  </p>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
